import { useState } from 'react';
import { Link } from 'react-router';
import { useProjects } from '../hooks/useApi';
import { CreateProjectModal } from '../components/CreateProjectModal';

export function ProjectsPage() {
  const { data: projects, isLoading, error } = useProjects();
  const [showCreate, setShowCreate] = useState(false);

  return (
    <div className="p-3 sm:p-6 max-w-5xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-semibold">Proyectos</h1>
        <button
          onClick={() => setShowCreate(true)}
          className="px-4 py-2 bg-vision-dark hover:bg-vision rounded-lg"
        >
          + Nuevo proyecto
        </button>
      </div>

      {isLoading && <div className="text-slate-400">Cargando…</div>}
      {error && <div className="text-red-400">Error: {(error as Error).message}</div>}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {projects?.map((p) => (
          <Link
            key={p.id}
            to={`/projects/${p.slug}`}
            className="block p-4 bg-slate-900 border border-slate-800 hover:border-vision rounded-xl transition-colors"
          >
            <div className="font-medium text-slate-100">{p.name}</div>
            {p.client && <div className="text-sm text-slate-400 mt-1">{p.client.name}</div>}
            {p.description && (
              <div className="text-sm text-slate-500 mt-2 line-clamp-2">{p.description}</div>
            )}
            {p.owner && (
              <div className="text-xs text-slate-500 mt-3 flex items-center gap-1">
                <span>👤</span>
                <span>{p.owner.name || p.owner.email}</span>
              </div>
            )}
          </Link>
        ))}
        {projects && projects.length === 0 && (
          <div className="col-span-full p-6 bg-slate-900 border border-dashed border-slate-700 rounded-xl text-slate-400 text-center">
            Sin proyectos. Creá el primero.
          </div>
        )}
      </div>

      {showCreate && <CreateProjectModal onClose={() => setShowCreate(false)} />}
    </div>
  );
}
